const PageSection = (props: any) => {
  return (
    <section className={`page-content wrapper ${props.className || ''}`}>
      <div className='content'>{props.children}</div>
    </section>
  );
};

export default PageSection;
